import { combineEpics, Epic } from 'redux-observable';

import { authEpics } from './auth';
import { cartEpics } from './cart';
import { feedbackEpics } from './feedback';

export const epics: Epic = combineEpics(authEpics, feedbackEpics, cartEpics);
